/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import dayjs from "dayjs";

const SAVED_DATE_FORMAT = "YYYY-MM-DD";

export const toSavedDate = (value) => {
  if (!value) return null;
  const date = dayjs.isDayjs(value) ? value : dayjs(value?.$d || value);
  return date.isValid() ? date.format(SAVED_DATE_FORMAT) : null;
};

// Only an exact "YYYY-MM-DD" that round-trips is accepted, so "2026-02-31" is rejected.
export const fromSavedDate = (value) => {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = dayjs(value);
  return date.isValid() && date.format(SAVED_DATE_FORMAT) === value ? date.startOf("day") : null;
};

export const toSavedOption = (id, label) => ({ id, label: label ? `${label}` : `${id}` });

export const toSavedOptions = (ids, getLabel) => ids.map((id) => toSavedOption(id, getLabel(id)));

const isSavedOption = (option) =>
  Boolean(option) && typeof option === "object" && !Array.isArray(option) &&
  option.id !== null && option.id !== undefined && option.id !== "";

export const savedOptionId = (option) => (isSavedOption(option) ? option.id : null);

export const savedOptionList = (options) => (Array.isArray(options) ? options.filter(isSavedOption) : []);

// Adds saved options a dropdown hasn't loaded yet, so their labels show; loaded ones are kept as is.
export const seedOptionsCache = (current, seeds, key) => {
  const missing = seeds.filter((seed) => !current.some((option) => `${option?.[key]}` === `${seed[key]}`));
  return missing.length ? [...current, ...missing] : current;
};
